<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Business Type</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <customBusinessTypeForm
					:customBusinessType="tempCustomBusinessType"
					@canSaveCustomBusinessType="canSaveCustomBusinessType = $event"
				></customBusinessTypeForm>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import customBusinessTypeForm from './customBusinessTypeForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempCustomBusinessType: null,
				defaultCustomBusinessType: {
					id: 0,
					name: "",
					description: "",
					supplierId: 0
				},
				canSaveCustomBusinessType: false,
            }
        },
        created: function() {
			this.defaultCustomBusinessType.supplierId = this.account.supplierId
            this.tempCustomBusinessType = JSON.parse(JSON.stringify(this.defaultCustomBusinessType))
        },
        computed: {
            ...mapGetters([
				'account',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createCustomBusinessType'
            ]),
            save: function() {
				if(!this.canSaveCustomBusinessType) {
					this.$toasted.error('Please fill in all required fields');
					return
				}
                this.createCustomBusinessType(this.tempCustomBusinessType).then(
                    this.close()
                )
            },
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            customBusinessTypeForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// createCustomBusinessType.vue?012896f7